const groupSelect = document.getElementById('favorite_group');
const favoriteSelect = document.getElementById('favorite_favoriteList');
const hideWhenNoListEl = document.querySelector('.js-hide-when-no-lists');
const newFavoListButton = document.querySelector('.js-new-favo-list');
const newFavoListName = document.getElementById('favorite_name');
const favoriteForm = document.querySelector('form[name="favorite"]');
const errorEl = document.querySelector('.js-favorite-list-error');

let allOptions = [];
let favoriteSelectTs = null;

if (newFavoListButton) {
    allOptions = Array.from(favoriteSelect.querySelectorAll('option')).map(option => ({
        value: option.value,
        text: option.text,
        groupId: option.dataset.groupId
    }));

    favoriteSelectTs = favoriteSelect.tomselect;

    errorEl.innerHTML = '';

    let groupValue = groupSelect.value;

    filterFavoritesByGroup(groupValue);

    groupSelect.addEventListener('change', function(event) {
        groupValue = event.target.value;

        filterFavoritesByGroup(groupValue);
    });

    newFavoListButton.addEventListener('click', function(e) {
        e.preventDefault();

        newFavoListName.parentElement.parentElement.classList.toggle('d-none');
    });
}

if (favoriteForm) {
    favoriteForm.addEventListener('submit', function (event) {
        event.preventDefault();

        if ('' === favoriteSelect.value && '' === newFavoListName.value) {
            errorEl.innerHTML = 'Gelieve een favorietenlijst te kiezen of aan te maken.';

            return;
        }

        favoriteForm.submit();
    });
}

function filterFavoritesByGroup(groupValue) {
    errorEl.innerHTML = '';
    favoriteSelectTs.clearOptions();
    let firstOptionValue = null;

    allOptions.forEach(option => {
        if (option.groupId === groupValue) {
            favoriteSelectTs.addOption({ value: option.value, text: option.text });

            if (null === firstOptionValue) {
                firstOptionValue = option.value;
            }
        } else {
            favoriteSelectTs.removeOption(option.value);
        }
    });

    if (null !== firstOptionValue) {
        favoriteSelectTs.setValue(firstOptionValue);

        hideWhenNoListEl.classList.remove('d-none');
    }

    if (0 === Object.keys(favoriteSelectTs.options).length) {
        hideWhenNoListEl.classList.add('d-none');
    }
}
